import { useMemo } from "react";
import { useSelector as useReduxSelector } from "react-redux";
import classNames from "classnames";

import cardStyles from "./CardBlock.module.scss";

export const CardBlock = ({ title, title_en, desc, desc_en, image }) => {
  const { language } = useReduxSelector(
    (state) => state.LangSlice || { language: "ru" }
  );

  const plainTitle = useMemo(() => {
    const raw = language === "en" ? title_en : title;
    return (raw || "").replace(/<[^>]*>/g, "").trim() || "Service image";
  }, [language, title, title_en]);

  return (
    <div className={classNames("d-flex", cardStyles.root)}>
      <div
        className={cardStyles.imageBlock}
        style={{
          background: image
            ? `url(${image}) center / cover no-repeat`
            : undefined,
        }}
      >
        {image && <img src={image} alt={plainTitle} loading="lazy" />}
      </div>

      <div className={cardStyles.titleInfoBlock}>
        <div className={cardStyles.titleBlock}>
          {language === "en" ? (
            <p dangerouslySetInnerHTML={{ __html: title_en || "" }} />
          ) : (
            <p dangerouslySetInnerHTML={{ __html: title || "" }} />
          )}
        </div>
        <br />
        <div className={cardStyles.infoBlock}>
          {language === "en" ? (
            <p dangerouslySetInnerHTML={{ __html: desc_en || "" }} />
          ) : (
            <p dangerouslySetInnerHTML={{ __html: desc || "" }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default CardBlock;
